<template>
  <div class="top-user">
    <el-dropdown>
      <span class="el-dropdown-link">
        <el-avatar :size="40" shape="square" :src="userAvatar"></el-avatar>
        <span class="username">{{ userInfo?.atName | truncate }}</span>
        <i class="el-icon-arrow-down"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="handleHome" v-if="isHome"
          >去往首页</el-dropdown-item
        >
        <el-dropdown-item v-if="isMember" @click.native="handleMember"
          >会员中心</el-dropdown-item
        >
        <el-dropdown-item v-if="isUserInfo" @click.native="handleUserInfo"
          >个人中心</el-dropdown-item
        >
        <el-dropdown-item v-if="isProductDoc" @click.native="handleProductDoc"
          >产品文档</el-dropdown-item
        >
        <el-dropdown-item @click.native="handleOfficialWebsite"
          >山禾官网</el-dropdown-item
        >
        <el-dropdown-item divided @click.native="handleLogout"
          >退出系统</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import request from "@/utils/request";
import { clearToken, clearUserInfo, getUserInfo } from "@/utils/userInfo";
import { GET_USER_INFO_API } from "@/utils/requestUrl";

export default {
  name: "TopUser",

  props: {
    isHome: {
      type: Boolean,
      default: true,
    },
    isMember: {
      type: Boolean,
      default: true,
    },
    isUserInfo: {
      type: Boolean,
      default: true,
    },
    isOrder: {
      type: Boolean,
      default: true,
    },
    isProductDoc: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      userInfo: {},
      userAvatar: "",
    };
  },
  mounted() {
    this.userInfo = getUserInfo();
    this.userAvatar = GET_USER_INFO_API + this.userInfo.avatar;
  },
  methods: {
    // 退出系统
    handleLogout() {
      request.get("/user/logout").then((res) => {
        clearToken();
        clearUserInfo();
        this.$message.success({
          message: "退出成功",
          duration: 1000,
        });
        setTimeout(() => {
          this.$router.push("/introduction");
        }, 1000);
      }).catch(err => {
        console.error(err);
      });
    },
    // 个人中心
    handleUserInfo() {
      this.$router.push("/userInfo");
    },
    // 官网
    handleOfficialWebsite() {
      window.open("https://www.shanhe.link/", "_blank");
    },
    // 首页
    handleHome() {
      this.$router.push("/");
    },
    // 会员中心
    handleMember() {
      this.$router.push("/member/shanhe");
    },
    // 产品文档
    handleProductDoc() {
      this.$router.push("/productDoc");
    },
  },
};
</script>

<style lang="scss" scoped>
.top-user {
  cursor: pointer;
}

.el-dropdown-link {
  display: flex;
  align-items: center;
  
  .el-avatar {
    margin-right: 10px;
  }
  
  .username {
    margin-right: 5px;
  }
  
  .el-icon-arrow-down {
    font-size: 12px;
  }
}
</style>
